import { React, useEffect, useState } from "react";
import { Button, Form, Input, Select, Col, Row, Checkbox, Radio } from "antd";
import Iconmoon from "../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  DropDownSearchDraw,
} from "../styledElements";
import alertGreen from "../../Assets/Icons/alertGreen.svg";
import alertRed from "../../Assets/Icons/alertRed.svg";
import RightDrawerSidebar from "../../Components/RightDrawer/rightDrawer";
import { getMachineGradeSelect, setOrderType } from "../../Services/settingsServices";
import { addStockSize, deleteStockSize, editStockSize } from "../../Services/productServices";
import AlertContainer from "../../Components/AlertBoxes/alertBox";
import warning from "../../Assets/Icons/warning.png";
import ConfirmationModal from "../../Components/Modal/ConfirmationModal";
import { getUnitData } from "../../Services/measurementService";
import {
  lengthUnit,
  weightUnit,
currency_List,
conversionFactorUnitsToTonne,
conversionFactorTonneToUnits
} from "../../Utils/Constant/MeasurementUnitList.jsx";

const { Option } = Select;
const grainTypeData = [{label: "Long Grain", value: "long"}, {label: "Short Grain", value: "short"}];
const deckleWidthUnitData = ["mm", "cm"];
const plyData = [
  { label: "Single Ply", value: 1 },
  { label: "Double Ply", value: 2 },
  { label: "3-Ply", value: 3 },
  { label: "4-Ply", value: 4 },
];
// const orderTypeData = ["Sheet", "Reel"];
const { TextArea } = Input;

const AddNewSize = (props) => {
  const [units, setUnits] = useState({ widthUnit: "cm", coreUnit: "cm" });
  const [form] = Form.useForm();

  const [selectedType, setSelectedType] = useState();
  const stockStatusTab = [
    { label: "Active", value: "active" },
    {
      label: "Disabled",
      value: "disabled",
    },
  ];
  const [stockStatus, setStockStatus] = useState(props.isAddNewStockClicked ? "active" : props.selectedStockSize ? props.selectedStockSize.status : "active");
  const [validateData, setValidateData] = useState({
    type: "",
    grain: "",
  });
  const [orderTypes, setOrderTypes] = useState([]);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [errorMsg, setErrorMsg] = useState();
  const [viewDelete, setViewDelete] = useState(false);
  const [unitData,setUnitData] = useState();
  const [isStockInSystem, setIsStockInSystem] = useState(false);
  const [inventoryQuantErr, setInventoryQuantErr] = useState(false);
  const [isPlyDropdownOpen, setPlyDropdown] = useState(false);

  const handleQuantityChange = (e) => {
    if(props.isEditStockClicked){
      let quantityUnit = form.getFieldValue("inventory_unit");
      let convertedQuantToTonne = e.target.value * conversionFactorUnitsToTonne[quantityUnit];
      let convertedQuantTonneToUnit = convertedQuantToTonne * conversionFactorTonneToUnits[props?.selectedStockSize?.units?.quantity];
      if((props?.selectedStockSize?.stock_in_system > convertedQuantTonneToUnit) && e.target.value){
        setInventoryQuantErr(true);
      } else{
        setInventoryQuantErr(false);
      }
    }
  };

  const handleUnitChange = (e) => {
    if(props.isEditStockClicked){
      let quantityValue = form.getFieldValue("quantity");
      let convertedQuantToTonne = quantityValue * conversionFactorUnitsToTonne[e];
      let convertedQuantTonneToUnit = convertedQuantToTonne * conversionFactorTonneToUnits[props?.selectedStockSize?.units?.quantity];
      if((props?.selectedStockSize?.stock_in_system > convertedQuantTonneToUnit) && quantityValue){
        setInventoryQuantErr(true);
      } else{
        setInventoryQuantErr(false);
      }
    }
  };

  const handleStatusChange = (e) => {
    setStockStatus(e.target.value);
  };

  const OnPlyToggleSelect = () => {
    setPlyDropdown((prevState) => !prevState);
  };

  useEffect(() => {
    setIsStockInSystem(props.selectedStockSize?.stock_in_system > 0);
    getMachineGradeSelect()
      .then((response) => {
        const reelValue = response.data.data.settings.order_types[0].value;
        const sheetValue = response.data.data.settings.order_types[1].value;
        const typeData =
          reelValue && sheetValue
            ? [
                { label: "Reel", value: "reel" },
                { label: "Sheet", value: "sheet" },
              ]
            : reelValue
            ? [{ label: "Reel", value: "reel" }]
            : sheetValue
            ? [{ label: "Sheet", value: "sheet" }]
            : [];
        setOrderTypes(typeData);
        if (props.isAddNewStockClicked)
          setSelectedType(typeData[0].value);
        else
          setSelectedType(props.selectedStockSize ? props.selectedStockSize.type : typeData[0].value)
        setValidateData({
          ...validateData,
          type: typeData?.length ? typeData[0]["value"] : [],
        });
      })
      .catch((error) => console.log(error));
      getUnitData().then((response) => {
        setUnitData(response.data);
        
      })
      .catch((error) => {
        console.log(error);
      });
    return () => {
      setOrderTypes([]);
    };
  }, []);

  const handleType = (e) => {
    setValidateData({ ...validateData, type: e })
    setSelectedType(e);
  };

  const modalShowDelete = () => {
    setViewDelete(true);
  };

  const modalCancelDelete = () => {
    setViewDelete(false);
  };

  const handleClose = () => {
    setSelectedType("");
    setValidateData({
      type: "",
      grain: "",
    });
    form.resetFields();
    props.onClose();
  };

  const onChangeWidthUnit = (e) => {
    setUnits({ ...units, widthUnit: e });
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const onFinish = (e = {}) => {
    if (props.isAddNewStockClicked) {
      const req = {
        type: selectedType,
        product: props.productCode,
        status: stockStatus,
        quantity: parseFloat(e.quantity),
        ...(selectedType === "reel" && {
          ply: parseFloat(e?.ply)
        }),
        units : {
          quantity : e.inventory_unit,
          width : e.dimensionUnit
        }
      };
     
          req["width"] = parseFloat(e.width);
        
      if (selectedType === "sheet") {
       
        req["length"] = parseFloat(e.length);
        req["grain"] = e.grain;
        req.units['length'] = e.dimensionUnit;
        req['ply'] = 1;
      }
      addStockSize(req)
        .then((response) => {
          props.rendering(true);
          props.toasterAction({
            error: response.error,
            msg: response.msg,
          });
          props.showToaster();
        })
        .catch((error) => {
          props.toasterAction({
            error: error.response.data.error,
            msg: error.response.data.msg,
          });
          props.showToaster();
        });
    }
    else if (props.isEditStockClicked) {
      const req = {
        type: selectedType,
        status: stockStatus,
        quantity: parseFloat(e.quantity),
        ...(selectedType === "reel" && {
          ply: parseFloat(e?.ply)
        }),
        units : {
          quantity : e.inventory_unit,
          width : e.dimensionUnit
        }
      };
      
      req["width"] = parseFloat(e.width);
        
      if (selectedType === "sheet") {
       
        req["length"] = parseFloat(e.length);
        req["grain"] = e.grain;
        req.units['length'] = e.dimensionUnit;
        req['ply'] = 1;
      }
      editStockSize(props.productCode, props.selectedStockSize.id, req)
        .then((response) => {
          props.rendering(true);
          props.toasterAction({
            error: response.error,
            msg: response.msg,
          });
          props.showToaster();
        })
        .catch((error) => {
          props.toasterAction({
            error: error.response.data.error,
            msg: error.response.data.msg,
          });
          props.showToaster();
        });
    }
    else if (props.isViewStockClicked) {
      setViewDelete(false);
      deleteStockSize(props.selectedStockSize.id)
      .then((response) => {
        props.rendering(true);
        props.toasterAction({
          error: response.error,
          msg: response.msg,
        });
        props.showToaster();
      })
      .catch((error) => {
        props.toasterAction({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
        props.showToaster();
      });
    }
    else {

    }
    props.onClose();
    form.resetFields();
    setSelectedType("");
    setValidateData({
      type: "",
      grain: "",
    });
  };

  const onFinishFailed = () => {
    scrollToTop();
  };

  return orderTypes.length > 0 && unitData ? (
    <RightDrawerSidebar
      title={props.isAddNewStockClicked ? "Add Stock Size" : props.isViewStockClicked ? props.selectedStockSizeRow ? 
      props.selectedStockSizeRow.size : "" : props.isEditStockClicked ? "Edit Stock Size" : ""}
      subtitle=""
      visible={props.visible}
      onClose={handleClose}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          {/* Toasters */}

          {/* <AlertContainer color="blue" icon={alertBlue} msg="You can't modify a grade once added. A grade can only be deleted if there is no product created for that grade" /> */}
          <DetailFields className="marginBtnP">
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                form={form}
              >
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Product Specifications</h5>
                    <p>Combination of Grade/GSM/BF/Quality/Moisture</p>
                  </div>
                  <Form.Item
                    name="product_spec"
                    // rules={[{ required: true }]}
                    className="dBlock"
                    initialValue={props.productSpec}
                  >
                    <Input placeholder="Product Specification" disabled />
                  </Form.Item>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Order type</h5>
                    <p>The order can be of reel or sheet type</p>
                  </div>
                  <Form.Item
                    name="type"
                    rules={[
                      { required: true, message: "This field is required" },
                    ]}
                    className="selectForm"
                    initialValue={
                      props.isAddNewStockClicked ? orderTypes.length ? orderTypes[0]["value"] : null : props.selectedStockSize ? props.selectedStockSize.type : null
                    }
                  >
                    <Select
                      placeholder="Select"
                      suffixIcon={<DownArrowDraw />}
                      onChange={handleType}
                      disabled={props.isViewStockClicked ? true : (props.selectedStockSizeRow && isStockInSystem) ? true : false}
                    >
                      {orderTypes.map((orderType) => (
                        <Option key={orderType.value}>{orderType.label}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                 {selectedType == "reel" && 
                                (<div className="drawerField">
                                  <div className="titleWithText">
                                    <h5>Ply Count</h5>
                                    <p>Count of ply in the product to be produced</p>
                                  </div>
                                  <Form.Item
                                    name="ply"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This field is required",
                                      },
                                    ]}
                                    className="selectForm"
                                    initialValue={props.isAddNewStockClicked ? "" : props.selectedStockSize ? props.selectedStockSize.ply : ""}

                                  >
                                    <Select
                                      placeholder="Select Ply"
                                      suffixIcon={
                                        isPlyDropdownOpen ? (
                                          <DropDownSearchDraw />
                                        ) : (
                                          <DownArrowDraw />
                                        )
                                      }
                                      onBlur={OnPlyToggleSelect}
                                      onFocus={OnPlyToggleSelect}
                                      showSearch
                                      optionFilterProp="children"
                                      disabled={props.isViewStockClicked ? true : (props.selectedStockSizeRow && isStockInSystem) ? true : false}
                                      // onChange={handleProduct}
                                    >
                                      {plyData.map((item) => (
                                        <Option key={item.value}>
                                          {item.label}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </div>)}
                {orderTypes.length
                  ? selectedType === "sheet" && (
                      <div className="drawerField">
                        <div className="titleWithText">
                          <h5>Grain</h5>
                          <p>The order can be of long or short grain</p>
                        </div>
                        <Form.Item
                          name="grain"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          className="selectForm"
                          style={{ marginBottom: 4 }}
                          initialValue={props.isAddNewStockClicked ? grainTypeData[0]["value"] : props.selectedStockSize ? props.selectedStockSize.grain : grainTypeData[0]["value"]}
                        >
                          <Select
                            placeholder={"Select"}
                            suffixIcon={<DownArrowDraw />}
                            // onChange={findPlannedReels}
                            onChange={(e) =>
                              setValidateData({ ...validateData, grain: e })
                            }
                            disabled={props.isViewStockClicked ? true : (props.selectedStockSizeRow && isStockInSystem) ? true : false}
                          >
                            {grainTypeData.map((grainType) => (
                              <Option key={grainType.value}>{grainType.label}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <div className="italicsTitleWithText">
                          <p>
                            {validateData.grain === "Long Grain"
                              ? "The width will be matched in deckle matching"
                              : validateData.grain === "Short Grain" &&
                                "The length will be matched in deckle matching"}
                          </p>
                        </div>
                      </div>
                    )
                  : null}
                <div className="drawerField removeStar">
                  <div className="titleWithText">
                    <h5>Dimension</h5>
                    <p>
                      {selectedType === "reel" ? (
                        <>The width of the inventory stock</>
                      ) : (
                        <>The width and length of the inventory stock</>
                      )}
                    </p>
                  </div>
                  <Row className="centerAlign justifyCSBetween">
                    {(selectedType === "sheet" || validateData.type === "sheet") && (
                      <Col span={8}>
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <Form.Item
                            label="Length"
                            name="length"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                                message:
                                  "Upto 2 decimal point values is accepted",
                              },
                            ]}
                            className="dBlock"
                            initialValue={props.isAddNewStockClicked ? "" : props.selectedStockSize ? props.selectedStockSize.length : ""}
                          >
                            <Input
                              placeholder="Length"
                              onChange={(e) =>
                                setValidateData({
                                  ...validateData,
                                  length: e.target.value,
                                })
                              }
                              disabled={props.isViewStockClicked ? true : (props.selectedStockSizeRow && isStockInSystem) ? true : false}
                            />
                          </Form.Item>
                        </div>
                      </Col>
                    )}
                    <Col span={selectedType === "sheet" ? 8 : 13}>
                      <div className="boxFormType">
                        <Form.Item
                          label="Width"
                          name="width"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                              message:
                                "Upto 2 decimal point values is accepted",
                            },
                          ]}
                          className="dBlock"
                          initialValue={props.isAddNewStockClicked ? "" : props.selectedStockSize ? props.selectedStockSize.width : ""}
                        >
                          <Input
                            placeholder="Width"
                            onChange={(e) =>
                              setValidateData({
                                ...validateData,
                                width: e.target.value,
                              })
                            }
                            disabled={props.isViewStockClicked ? true : (props.selectedStockSizeRow && isStockInSystem) ? true : false}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col span={selectedType === "sheet" ? 7 : 10}>
                      <div className="boxFormType unitSelect">
                        <Form.Item
                          label="Unit"
                          name="dimensionUnit"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          className="dBlock"
                          initialValue={props.isAddNewStockClicked ? unitData.units_management.length.default :  props.selectedStockSize ?  props.selectedStockSize.units.width : ''}
                        >
                          <Select
                            placeholder="Unit"
                            suffixIcon={<DownArrowDraw />}
                            onChange={onChangeWidthUnit}
                            disabled={props.isViewStockClicked ? true : (props.selectedStockSizeRow && isStockInSystem) ? true : false}
                          >
                            {unitData.units_management.length.data.map((deckleWidth) => (
                              <Option key={deckleWidth} value={deckleWidth}>
                                {lengthUnit[deckleWidth].displayName}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Inventory Quantity</h5>
                    <p>The quantity allowed to stock in the inventory</p>
                  </div>
                  <>
                  <Row className="centerAlign justifyCSBetween">
                  <Col span={16}>
                    <div className="boxFormType" style={{ marginBottom: "0" }}>
                    <Form.Item
                        name="quantity"
                        rules={[
                          {
                            required: true,
                            message: "This field is required",
                          },
                          {
                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                            message: "Only decimal characters are allowed",
                          },
                          {
                            validator: (_, value) => {
                              if (props.selectedStockSizeRow && +(props.selectedStockSizeRow.stockInSystem.replace(" TONNE", "")) >= value) {
                                return Promise.reject('Updated quantity should be greater than stock in system');
                              }
                              else {
                                return Promise.resolve();
                              }
                            }
                          }
                        ]}
                        className=""
                        initialValue={props.isAddNewStockClicked ? "" : props.selectedStockSize ? props.selectedStockSize.quantity : ""}
                      >
                        <Input
                          placeholder="Enter weight"
                          onChange={handleQuantityChange}
                          disabled={props.isViewStockClicked ? true : false}
                        />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col span={7}>
                    <div
                      className="boxFormType unitSelect"
                      style={{ marginBottom: "0" }}
                    >
                      <Form.Item
                        name="inventory_unit"
                        rules={[{ required: true }]}
                        className="dBlock"
                        initialValue={props.isAddNewStockClicked ? unitData.units_management.weight.default : props.selectedStockSize ?  props.selectedStockSize.units.quantity : ''}
                      >
                        <Select
                            placeholder="Unit"
                            suffixIcon={<DownArrowDraw />}
                            onChange={(e) => {
                              handleUnitChange(e);
                            }}
                            disabled={props.isViewStockClicked ? true : false}
                          >
                            {unitData.units_management.weight.data.map((deckleWidth) => (
                              <Option key={deckleWidth}>{weightUnit[deckleWidth].displayName}</Option>
                            ))}
                          </Select>
                      </Form.Item>
                    </div>
                  </Col>
                  <Col style={{marginTop:"-22px"}}>
                    {inventoryQuantErr ? (
                        <span
                          className="errorText"
                          style={{
                            color: "#ea4e2c"
                          }}
                        >
                        Inventory quantity cannot be less than in-stock quantity {"( " + props?.selectedStockSize?.stock_in_system?.toFixed(3) + " " + weightUnit[props?.selectedStockSize?.units?.quantity]?.displayName + " )"}
                        </span>
                       ) : null}
                    </Col>
                </Row>
                    
                  </>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Status</h5>
                    <p>The size will be considerable only if it is enabled </p>
                  </div>
                  <div
                    className=" switchRadio twoSwitch"
                    style={{ justifyContent: "center", display: "flex" }}
                  >
                    <Radio.Group
                      disabled={props.isViewStockClicked ? true : false}
                      options={stockStatusTab}
                      optionType="button"
                      buttonStyle="solid"
                      value={stockStatus}
                      onChange={handleStatusChange}
                    />
                  </div>
                </div>
                
                {props.isViewStockClicked &&
                  <div className="buttonFlex fixedBtm">
                    <Form.Item>
                      <Button className="themeBtn" onClick={modalShowDelete}
                        disabled={props.selectedStockSize ? (props.in_process + props.in_production + props.completed) > 0 ? true : false : true}>
                        <Iconmoon icon="delete" size={16} color="#ffffff" />{" "}
                        Delete Size
                      </Button>
                    </Form.Item>
                  </div>
                }
                {(props.isAddNewStockClicked || props.isEditStockClicked) &&
                  <div className="buttonFlex fixedBtm">
                    <Form.Item>
                      <Button htmlType="submit" className="themeBtn">
                        <Iconmoon icon={props.isAddNewStockClicked ? "addcircle" : "edit"} size={16} color="#ffffff" />{" "}
                        {props.isAddNewStockClicked ? "Add Size " : "Save Changes "}
                      </Button>
                    </Form.Item>
                    <Form.Item>
                      <Button
                        key="3"
                        className="textTypeBtn"
                        onClick={handleClose}
                      >
                        Cancel changes
                      </Button>
                    </Form.Item>
                  </div>
                }
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
        <ConfirmationModal
            visible={viewDelete}
            icon={warning}
            cancelAction={modalCancelDelete}
            confirmAction={() => form.submit()}
          >
            <span>Delete size?</span>
            <p>
              The size and related information will be deleted. Are you sure you want to continue?
            </p>
          </ConfirmationModal>

          {success && (
            <AlertContainer
              color="green toaster"
              icon={alertGreen}
              closeIcon={true}
              setClose={setSuccess}
              msg={successMsg}
            />
          )}

          {error && (
            <AlertContainer
              color="red toaster"
              icon={alertRed}
              closeIcon={true}
              setClose={setError}
              msg={errorMsg}
            />
          )}
      </RightDrawerContainer>
    </RightDrawerSidebar>
  ):null;
};

export default AddNewSize;
